import "./load-status-cell.css";

import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Button } from "@tql/ui-components-react/tql/buttons";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type { Load } from "~/shared/schemas/loads-schema";
import { getFormattedLoadStatus } from "~/shared/utils/load-status-fns.ts";

type LoadStatusCellProps = Omit<GridCustomCellProps, "dataItem"> & {
	dataItem: Load;
	isInternal?: boolean;
};

export const LoadStatusCell = (props: LoadStatusCellProps) => {
	const { dataItem, isInternal } = props;

	const getClassName = () => {
		if (dataItem.loadStatus === "EXCEPTION" && isInternal) {
			return "load-status-exception";
		}
		return dataItem.loadStatus.toLowerCase();
	};

	return (
		<GridTd tdProps={props.tdProps}>
			<div
				className={`load-status-button ${getClassName()} ${isInternal && dataItem.isImmediateAction ? "needs-attention" : ""} ${isInternal && dataItem.isNeedsAcknowledged ? "needs-acknowledged" : ""}`}
			>
				<Button>
					{dataItem.formattedStatus ||
						getFormattedLoadStatus(dataItem.loadStatus)}
				</Button>
			</div>
		</GridTd>
	);
};
